module.exports = __webpack_public_path__ + "339986cea51b40a4bd6d161270e417b9.svg";